const NoPage=()=>{
    return(<>
    <h4> 404 Page not found</h4>
    </>)
}

export default NoPage;